import { FC } from 'react'
import { MdAutoAwesome } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Headline from '../../../Elements/Headline'
import Text from '../../../Elements/Text'
import Button from '../../../Formik/Button'
import { useCreateBudget } from '../../lib/Hooks/Budget'

interface Props {
  startAIGuide: () => void
}

const MainView: FC<Props> = ({ startAIGuide }) => {
  const { t } = useTranslation(['budget'])
  const { mutateAsync: createBudget, isPending: isCreateLoading } =
    useCreateBudget()

  const navigate = useNavigate()

  return (
    <>
      <div className='flex'>
        <div
          onClick={startAIGuide}
          className='w-1/2 pr-5 border-r flex flex-col cursor-pointer'
        >
          <Headline size='lg'>
            {t('budget:mainView.aiTitle')}
            <MdAutoAwesome
              size='1.25rem'
              className='ml-2 mb-1 inline fill-yellow-400'
              title={t('budget:mainView.aiIconTitle')}
            />
          </Headline>
          <Text className='my-5'>{t('budget:mainView.aiDescription')}</Text>
          <img src='/images/budget_ai.png' className='w-full mb-5' />
          <div className='flex items-center mt-auto'>
            <Button loading={false}>{t('budget:mainView.aiTitle')}</Button>
            <Text className='ml-5 font-bold'>
              {t('budget:mainView.aiPrice')}
            </Text>
          </div>
        </div>
        <div
          onClick={async () => {
            const budget = await createBudget()
            return navigate(`/budget/${budget.id}/`)
          }}
          className='w-1/2 pl-5 flex flex-col items-start cursor-pointer'
        >
          <Headline size='lg'>{t('budget:mainView.emptyTitle')}</Headline>
          <Text className='my-5 w-full'>
            {t('budget:mainView.emptyDescription')}
          </Text>
          <img src='/images/budget_scratch.png' className='w-full mb-5' />
          <div className='mt-auto'>
            <Button loading={isCreateLoading}>
              {t('budget:mainView.emptyButton')}
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}
export default MainView
